export const languageConstants = {
	LANGUAGE_UPDATE: 'LANGUAGE_UPDATE'
};
